import {SOPostStep} from '../../core/step/so-post-step';
import {StepCore} from './step.core';
import {SOGetStep} from '../../core/step/so-get-step';
import {FormField, SelectionOption} from 'lionheartland';
import {postStepFormFieldOptions} from './post-step-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {ProcessStepAssociationCore} from '../process-step-association/process-step-association.core';
import {SOGetProcessStepAssociation} from '../../core/process-step-association/so-get-process-step-association';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostStep extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postStepFormFieldOptions);

  RequestClass = SOPostStep

  constructor(
    public entityCore: StepCore
  ) {
    super();
    if (postStepFormFieldOptions.processStepAssociations) {
      postStepFormFieldOptions.processStepAssociations.makeCore = true;
    }
    if (postStepFormFieldOptions.project) {
      postStepFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('stepNumber'),
      [this.getFormValueFromIdentifier('processStepAssociations', SOGetProcessStepAssociation)],
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}